import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { cn } from '@/lib/utils';

export function CampaignFormSectionCard({
  icon: Icon,
  title,
  description,
  actions,
  children,
  className,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Card className={cn('border-secondary border-4 bg-secondary', className)}>
      <CardHeader className="bg-secondary p-4 text-secondary-foreground">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <CardTitle className="flex items-center gap-2 text-base font-medium">
              <Icon data-icon="inline-start" className="size-4 shrink-0" />
              {title}
            </CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          {actions ? (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          ) : null}
        </div>
      </CardHeader>
      <CardContent className="rounded bg-background p-4">
        {children}
      </CardContent>
    </Card>
  );
}
